import React, {useEffect} from 'react';
import Logo from './img/403.png';
import './errorPage403.scss';
import {withRouter} from 'react-router-dom';
import {t} from 'react-switch-lang';

function ErrorPage403({history}) {

  // useEffect(() => {
  //   console.log(history);
  //   window.addEventListener('popstate', (event) => {
  //     history.go(-2);
  //   });
  // }, []);

  return (
    <div className="error-page-container-403 position-relative">
      <div className="d-inline-block position-absolute info-containter">
        <div className="errorCode d-flex justify-content-center align-items-center">
          <img src={Logo} alt="Logo" className="logo2" />
        </div>
        <div className="message-text">
          <span>{t('errorPages.forbidden')}</span>
        </div>
        <div className="return-text">
          <button onClick={() => history.go(-2)}>
            {t('errorPages.return')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ErrorPage403);
